<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage ssLifeView"
  >
    <header-area />

    <div class="worksView" :class="readyAction ? 'ready-action' : ''">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">
              Breaking the frame of insurance <br />through the eyes of customers
            </div>
            <div class="workSlogan mobile">
              Breaking the frame of<br />insurance through <br />the eyes of customers
            </div>
            <div class="workTopDay">
              <p>삼성생명 디지털 채널 선진화</p>
              <ul>
                <li>PC / Mobile web / App</li>
                <li>2020.04.12</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://www.samsunglife.com" target="_blank" class="siteAddr"
                >https://www.samsunglife.com</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsunglife"
                    title="일상의 모든 순간을 함께하는 디지털 금융 플랫폼"
                    hashtags="플립커뮤니케이션즈,삼성생명"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/samsunglife"
                    title="일상의 모든 순간을 함께하는 디지털 금융 플랫폼"
                    hashtags="플립커뮤니케이션즈,삼성생명"
                    twitter-user="플립커뮤니케이션즈"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="15"
              >&nbsp;Breaking the frame of insurance through the eyes of customers</marquee-text
            ></span
          >
          <img class="web" src="@/assets/images/works_view/ssLife/ssLife_visual.png" alt="" />
          <img class="mobile" src="@/assets/images/works_view/ssLife/ssLife_visual_m.png" alt="" />
        </div>
      </div>

      <div class="contsBox wide">
        <div class="topInfo">
          삼성생명은 IT 기술이 발달함에 따라 점차 다양해지는 고객의 요구에 부응하고, 급변하는
          비즈니스 환경에 대응하기 위해 디지털 채널 선진화 프로젝트를 진행했습니다. 그간 인공지능 및
          빅데이터 기술 도입, 사용자 환경 관련 전문 인력 확충, R&D 투자 등을 통해 쌓아 온 디지털
          역량을 바탕으로 차별화된 온라인 서비스를 제공하고자 했으며, 특히 보험, 대출 등 금융 상품을
          중심으로 콘텐츠를 개선하고 PC/모바일 웹과 App을 아우르는 공통 플랫폼을 구축하는 데
          집중했습니다.
        </div>
      </div>
    </div>

    <kinesis-container event="scroll">
      <div class="wideConts">
        <!-- Goal -->
        <div class="ssLifeConcept">
          <div class="worksView">
            <div class="txtWrap">
              <div class="tit">GOAL</div>
              <p class="txt web">
                당사 디지털 채널에서 콘텐츠 및 서비스를 적극적으로 활용하는 <br />충성 고객층을
                확대시킬 수 있는 발판으로 삼고자 했습니다.
              </p>
              <p class="txt mobile">
                서비스를 적극적으로 이용하고 콘텐츠를 적극적으로<br />
                활용하는 디지털 채널 충성 고객을 확장 하기 위판<br />
                발판을 만들고자 한다.
              </p>
            </div>
            <div
              class="goalLineUp"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="order">
                <span>가망 고객</span>
                <span>가입 고객</span>
                <span>디지털 채널 고객</span>
                <span class="roundBox">디지털 채널<br />충성 고객</span>
                <div class="arrowLine">
                  <div class="bar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow.png" alt="" />
                  </div>
                </div>
              </div>
              <span class="roundBg one" />
              <span class="roundBg two" />
              <span class="roundBg three" />
            </div>
            <div class="conceptChange">
              <ul>
                <li>
                  <span class="before">
                    <strong>가망 고객</strong>
                    <p>금융 지식 부족<br />필요성 체감 미미<br />상품 구매 조건 불신</p>
                  </span>
                  <span class="after">
                    <p>공감을 불러일으키는 콘텐츠<br />친근하고 담백한 첫인상</p>
                  </span>
                </li>
                <li>
                  <span class="before">
                    <strong>가입 고객</strong>
                    <p>디지털 회원 전환 곤란<br />신속한 업무 처리 희망</p>
                  </span>
                  <span class="after">
                    <p>쉬운 디지털 회원 전환<br />간결한 프로세스</p>
                  </span>
                </li>
                <li>
                  <span class="before">
                    <strong>디지털 채널<br />고객</strong>
                    <p>서비스 검색 환경 불편<br />채널 재방문 의사 부족</p>
                  </span>
                  <span class="after">
                    <p>쉽고 간편한 UI<br />신규 콘텐츠와 활발한 업데이트</p>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- //Goal -->
        <!-- Main -->
        <div class="ssLifeConcept">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit">MAIN</div>
              <p class="txt web">
                접근성을 높인 모바일 중심의 금융 서비스를 제공합니다. <br />서비스 신청 및 조회,
                상품 정보 확인, 자주 묻는 질문 등 <br />가장 많이 찾는 정보를 전면 배치해 쉽고
                빠르게 접근할 수 있습니다.
              </p>
              <p class="txt mobile">
                접근성을 높인 모바일 중심의 금융 서비스를 제공합니다. 서비스 신청 및 조회, 상품 정보
                확인, 자주 묻는 질문 등 가장 많이 찾는 정보를 전면 배치해 쉽고 빠르게 접근할 수
                있습니다.
              </p>
            </div>
            <div
              class="imgBox"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div>
                <ul>
                  <li>
                    <p>TASK</p>
                    <div>
                      <img src="@/assets/images/works_view/ssLife/img_main_con1.jpg" alt="" />
                    </div>
                  </li>
                  <li>
                    <p>MARKETING</p>
                    <div>
                      <img src="@/assets/images/works_view/ssLife/img_main_con2.png" alt="" />
                      <div class="conceptCont type1">
                        <strong>공감대 확보를 통한 관계 형성</strong>
                        <p>일상 언어를 통해 타겟 고객의 <br />관심을 유도합니다.</p>
                      </div>
                      <div class="conceptCont type2">
                        <strong>콘텐츠를 통한 니즈 환기</strong>
                        <p>
                          보험/금융 관련 정보를 쉬운 콘텐츠로 제공해 <br />적합한 상품에 대한 니즈를
                          환기합니다.
                        </p>
                      </div>
                      <div class="conceptCont type3">
                        <strong>고객 중심 편의 서비스</strong>
                        <p>고객이 찾고자 하는 서비스를 <br />개인별로 맞춤 제공합니다.</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <p>GUIDANCE</p>
                    <div>
                      <img src="@/assets/images/works_view/ssLife/img_main_con3.jpg" alt="" />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="homepageRoliing"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="rollingArea">
                <div>
                  <img src="@/assets/images/works_view/ssLife/img_main_con4.png" alt="" />
                </div>
              </div>
            </div>
            <div class="conceptColor">
              <p class="web">
                삼성생명의 CI 컬러인 Samsung Blue를 톤업하여 밝고 경쾌한 느낌을 주고, <br />각
                상품군에서 도출된 주요 키워드와 어울리는 컬러를 선별해 채널 전체에 공통으로
                적용했습니다.
              </p>
              <p class="mobile">
                삼성생명의 CI 컬러인 Samsung Blue를 톤업하여 밝고 경쾌한 느낌을 주고, <br />각
                상품군에서 도출된 주요 키워드와 어울리는 컬러를 선별해 채널 전체에 공통으로
                적용했습니다.
              </p>
              <div class="colorBook">
                <ul>
                  <li>
                    <div class="color" />
                    <strong>Samsung Blue</strong>
                    <em>#3478f6</em>
                  </li>
                  <li>
                    <div class="color" />
                    <strong>Sub Blue</strong>
                    <em>#94b9ff</em>
                  </li>
                  <li>
                    <div class="color" />
                    <strong>Dark Blue</strong>
                    <em>#6175ba</em>
                  </li>
                  <li>
                    <div class="color" />
                    <strong>Violet</strong>
                    <em>#9a7ac9</em>
                  </li>
                  <li>
                    <div class="color" />
                    <strong>Green</strong>
                    <em>#49b59c</em>
                  </li>
                  <li>
                    <div class="color" />
                    <strong>Yellow-green</strong>
                    <em>#80b24f</em>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- //main -->
        <!-- Product -->
        <div class="ssLifeConcept type2">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit">PRODUCT</div>
              <p class="txt web">
                보험사 디지털 채널의 가장 중요한 목적은 상품 정보를 정확히 전달해 <br />고객이
                상품에 흥미를 갖도록 이끌고, 나아가 가입까지 연결시키는 일입니다.<br />그러나 수많은
                약정 조건과 어려운 보험 용어, 변화하는 정책 등의 정보를 <br />각자 다른
                라이프스타일을 지닌 불특정 고객에게 이해시키기란 어려운 일입니다.
              </p>
              <p class="txt mobile">
                보험사 디지털 채널의 가장 중요한 목적은 상품 정보를 정확히 전달해 고객이 상품에
                흥미를 갖도록 이끌고, 나아가 가입까지 연결시키는 일입니다. <br />그러나 수많은 약정
                조건과 어려운 보험 용어, 변화하는 정책 등의 정보를 각자 다른 라이프스타일을 지닌
                불특정 고객에게 이해시키기란 어려운 일입니다.
              </p>
              <p class="comma web">“ 고객의 라이프스타일과 탐색 경험을 고려한 상품 정보 전달 ”</p>
              <p class="comma mobile">
                “ 고객의 라이프스타일과<br />
                탐색 경험을 고려한 상품<br />
                정보 전달 ”
              </p>
            </div>
            <div
              class="sketchType"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="sketchMode">
                <strong>보험 메인</strong>
                <span class="bar top" />
                <span class="bar left" />
                <span class="bar right" />
                <span class="bar bottom" />
                <span class="bar bottom2" />
                <div class="arrowLine">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow.png" alt="" />
                  </div>
                </div>
                <span class="txt">스토리 상품 탐색</span>
                <span class="txt next">빠른 상품 탐색</span>
                <div class="arrowLine type2">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow2.png" alt="" />
                  </div>
                </div>
                <div class="arrowLine type2 next">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow2.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="sketchMode">
                <span class="bar top" />
                <span class="bar left2" />
                <span class="bar right2" />
                <span class="bar bottom" />
                <div class="arrowLine">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow.png" alt="" />
                  </div>
                </div>
                <span class="txt">카테고리 추천<em>(공감적 스토리)</em></span>
              </div>
              <div class="sketchMode">
                <strong>카테고리 메인</strong>
                <span class="bar top" />
                <span class="bar left" />
                <span class="bar right" />
                <span class="bar bottom" />
                <div class="arrowLine">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow.png" alt="" />
                  </div>
                </div>
                <div class="arrowLine next mobile">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow.png" alt="" />
                  </div>
                </div>
                <span class="txt">상품 추천<em>(인지적 스토리)</em></span>
                <div class="arrowLine type2 mobile">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow2.png" alt="" />
                  </div>
                </div>
                <div class="arrowLine type2 next mobile">
                  <div class="arrowBar" />
                  <div class="arrow">
                    <img src="@/assets/images/works_view/ssLife/ico_arrow2.png" alt="" />
                  </div>
                </div>
              </div>
              <div class="sketchMode">
                <strong>상품 화면</strong>
                <span class="bar top" />
                <span class="bar left" />
                <span class="bar right" />
                <span class="bar bottom" />
                <span class="txt">상품 상세<em>(합리적 정보)</em></span>
              </div>
            </div>
            <div class="txtWrap">
              <p class="txt">
                난해한 보험 용어를 고객이 이해하기 쉬운 언어로 변환하는 것을 넘어, 마케팅 관점에서
              </p>
              <p class="comma">“ 어떻게 하면 쉽고 간결하게 전달할 수 있을까 ” 에</p>
              <p class="txt">
                초점을 맞춰 상품군별 스토리텔링을 전개하고, 그에 적합한 내비게이션을 탑재했습니다.
              </p>
            </div>
            <div
              class="marketingView"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="slideBox">
                <div class="sec1Slider swiper-container">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con1.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con2.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con3.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con4.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con5.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con1.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con2.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con3.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con4.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con5.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con1.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con2.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con3.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con4.png" alt="" />
                    </div>
                    <div class="swiper-slide">
                      <img src="@/assets/images/works_view/ssLife/img_market_con5.png" alt="" />
                    </div>
                  </div>
                </div>
                <img src="@/assets/images/works_view/ssLife/img_market_con_b.png" alt="" />
              </div>
              <div class="phoneBox">
                <img src="@/assets/images/works_view/ssLife/img_market_con6.png" alt="" />
              </div>
              <div class="phoneBox">
                <img src="@/assets/images/works_view/ssLife/img_market_con7.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- //Product -->
        <!-- Contents -->
        <div class="ssLifeConcept type3">
          <div class="worksView">
            <div
              class="txtWrap"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="tit">CONTENTS</div>
              <p class="comma web">“ 상품 이해를 돕는 유기적인 콘텐츠 연계 ”</p>
              <p class="comma mobile">“ 상품 이해를 돕는 유기적인<br />콘텐츠 연계 ”</p>
              <p class="txt web">
                보험설계사가 고객과 만날 때 해주고 싶었던 이야기를 담은 <br />인터뷰와 카드뉴스
                콘텐츠를 ‘라이프&’에서 제공합니다.<br />‘요즘보험’, ‘팩트체크’, ‘라이프팁’ 등
                주제별로 분류하고 <br />관련 상품 페이지 하단에 배치해 상품에서 콘텐츠로,
                <br />콘텐츠에서 상품으로 순환되도록 구현했습니다.
              </p>
              <p class="txt mobile">
                보험설계사가 고객과 만날 때 해주고 싶었던 이야기를 담은 인터뷰와 카드뉴스 콘텐츠를
                ‘라이프&’에서 제공합니다. ‘요즘보험’, ‘팩트체크’, ‘라이프팁’ 등 주제별로 분류하고
                관련 상품 페이지 하단에 배치해 상품에서 콘텐츠로, 콘텐츠에서 상품으로 순환되도록
                구현했습니다.
              </p>
            </div>
            <div class="contMark1" />
            <div class="contMark2" />
            <div class="contMark3" />
            <div
              class="homepageRoliing mobileType"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="rollingArea">
                <div>
                  <img src="@/assets/images/works_view/ssLife/img_contents_con1.png" alt="" />
                </div>
              </div>
            </div>
            <div
              class="cardPerform"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <ul>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card3.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card4.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card5.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card3.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card4.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/images/works_view/ssLife/img_contents_card5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Contents -->
        <!-- LOGIN -->
        <div class="ssLifeConcept type2">
          <div class="worksView">
            <div class="txtWrap">
              <div class="tit">LOGIN</div>
              <p class="comma web">“ 다양한 인증 수단으로 안전하고 간편하게 ”</p>
              <p class="comma mobile">“ 다양한 인증 수단으로 <br />안전하고 간편하게 ”</p>
              <p class="txt web">
                불편했던 회원가입은 이제 안녕<br />모든 디지털 채널에서 일관된 사용자 경험을
                제공하기 위해 <br />공인인증서, 간편비밀번호, 카카오페이, 생체인증 등 다양한 인증
                수단을 구현했습니다.
              </p>
              <p class="txt mobile">
                불편했던 회원가입은 이제 안녕<br />모든 디지털 채널에서 일관된 사용자 경험을
                제공하기 위해 공인인증서, 간편비밀번호, 카카오페이, 생체인증 등 다양한 인증 수단을
                구현했습니다.
              </p>
              <p class="txt">
                이제 모바일 웹에서도 PC와 App과 동일한 수준의 금융 서비스를 이용할 수 있습니다.
              </p>
            </div>
            <div
              class="loginPerform"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="phoneBox">
                <img src="@/assets/images/works_view/ssLife/img_login_con.png" alt="" />
              </div>
              <div class="loginIcon one">
                <img src="@/assets/images/works_view/ssLife/img_login_icon1.png" alt="" />
              </div>
              <div class="loginIcon two">
                <img src="@/assets/images/works_view/ssLife/img_login_icon2.png" alt="" />
              </div>
              <div class="loginIcon three">
                <img src="@/assets/images/works_view/ssLife/img_login_icon3.png" alt="" />
              </div>
              <div class="loginIcon four">
                <img src="@/assets/images/works_view/ssLife/img_login_icon4.png" alt="" />
              </div>
              <div class="loginIcon five">
                <img src="@/assets/images/works_view/ssLife/img_login_icon5.png" alt="" />
              </div>
              <div class="loginIcon six">
                <img src="@/assets/images/works_view/ssLife/img_login_icon6.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <!-- LOGIN -->
        <!-- PROCESS -->
        <div class="ssLifeConcept type4">
          <div class="worksView">
            <div class="txtWrap">
              <div class="tit">PROCESS</div>
              <p class="comma web">“ 내 계약 현황을 한눈에, 효율적인 프로세스 ”</p>
              <p class="comma mobile">
                “ 내 계약 현황을 한눈에<br />
                효율적인 프로세스 ”
              </p>
              <p class="txt">
                보험금 청구, 대출 신청, 펀드 거래, 퇴직연금 가입 등 서비스 목적을 신속하게 달성할 수
                있도록 프로세스를 개편했습니다.<br />
                신청 과정에서 불필요한 안내성 문구와 메뉴별 인증 절차를 간소화하고 전체 프로세스
                대비 남은 단계를 한눈에 볼 수 있게 구현해 더욱 간편해졌습니다. <br />또한 가입을
                완료하지 못하더라도 입력했던 정보는 당일 내에 그대로 이어서 신청할 수 있어 신청 중
                이탈 가능성을 최소화했습니다.
              </p>
            </div>
            <div
              class="homepageRoliing"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <div class="rollingArea">
                <div>
                  <img src="@/assets/images/works_view/ssLife/img_main_con5.png" alt="" />
                </div>
              </div>
            </div>
            <div class="processCard">
              <div class="processList">
                <div class="phoneBox">
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con1.png" alt="" />
                  </div>
                </div>
                <div class="phoneBox">
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con2.png" alt="" />
                  </div>
                </div>
                <div class="phoneBox">
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con3.png" alt="" />
                  </div>
                </div>
                <div class="phoneBox explanType">
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con4.png" alt="" />
                  </div>
                  <div class="explan type1">보험계약대출 신청</div>
                </div>
                <div class="phoneBox explanType">
                  <div class="explan type2">소득공제 납입증명서</div>
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con5.png" alt="" />
                  </div>
                </div>
                <div class="phoneBox explanType">
                  <div class="explan type3 web">보험료 납입</div>
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con6.png" alt="" />
                  </div>
                  <div class="explan type3 mobile">보험료 납입</div>
                </div>
                <div class="phoneBox explanType">
                  <div class="explan type4 mobile">대출내역 현황</div>
                  <div class="img">
                    <img src="@/assets/images/works_view/ssLife/img_process_con7.png" alt="" />
                  </div>
                  <div class="explan type4 web">대출내역 현황</div>
                </div>
              </div>
            </div>
            <div class="ssLifeLogo">
              <img src="@/assets/images/works_view/ssLife/ssLife_logo.png" alt="" />
            </div>
          </div>
        </div>
        <!-- PROCESS -->
      </div>
    </kinesis-container>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-starF' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">스타필드 모바일 웹 &amp; 앱 리뉴얼</strong>
          <strong class="mobile">스타필드<br />모바일 웹 &amp; 앱 리뉴얼</strong>
        </div>

        <div class="engBg ionebankEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import VueKinesis from "vue-kinesis";
Vue.use(VueKinesis);

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '삼성생명'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "삼성생명 홈페이지 및 모바일 웹&앱 | 플립커뮤니케이션즈",
        title: "삼성생명 홈페이지 및 모바일 웹&앱",
        desc:
          "삼성생명은 디지털 채널 선진화 프로젝트를 통해 AI와 빅데이터 기술을 활용, 고객 맞춤형 온라인 서비스 제공에 주력했습니다. 특히 보험, 대출 등 금융상품 콘텐츠 개선과 모바일 웹/앱 공통 플랫폼 구축에 집중하여 접근성 높은 서비스를 제공하고 있습니다.",
        keywords:
          "삼성생명, 디지털 채널 선진화, PC, Mobile web, App, IT 기술, 고객 요구, 급변하는 비즈니스 환경, 인공지능, 빅데이터, 사용자 환경, R&D, 차별화된 온라인 서비스, 금융 상품, UI 개선",
        url: "https://www.pulip.com/works/samsungLife",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      icoInter: null,
      icoVal: 0
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/samsungLife").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    this.sec1Slider = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      spaceBetween: 60,
      speed: 1000,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      }
    });
  }
};
</script>
